import { Injectable } from '@angular/core';
import { SsrCookieService as CookieService } from 'ngx-cookie-service-ssr';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/lib/services/platform-information.service';
import {
  EmarsysBookingParameterRelatedTrackerDataInterface,
  EmarsysShopRelatedTrackerDataInterface,
  EmarsysTrackerDataInterface
} from '../../layout/interfaces/emarsys-tracker-data-interface';
import { ApiService } from '../../core/services/api.service';
import { BookingParametersInterface } from '../entities/bookingParameters';
import { DatePipe } from '@angular/common';
import { ShopListInterface } from '../interfaces/shop-list-interface';

@Injectable({
  providedIn: 'root'
})
export class EmarsysTrackerService {
  emarsysHash: string = undefined;
  platformShortCode: string;
  data: EmarsysTrackerDataInterface = {};

  constructor(
    private cookieService: CookieService,
    private platformInformationService: PlatformInformationService,
    private apiService: ApiService
  ) {
    this.platformShortCode = this.platformInformationService.getCurrentPlatformShortcode();
    if (this.platformShortCode === 'ar' && this.platformInformationService.getIsBrowser()) {
      this.emarsysHash = this.cookieService.get('ed_es_m');
    }
  }

  isActive(): boolean {
    return this.emarsysHash !== undefined && this.emarsysHash.length > 0;
  }

  track(data: EmarsysTrackerDataInterface) {
    if (this.isActive()) {
      this.apiService
        .trackEmarsysData(data, this.emarsysHash)
        .subscribe({ error: err => console.error(err) });
    }
  }

  getBookingParameterRelatedData(
    bookingParameters: BookingParametersInterface
  ): EmarsysBookingParameterRelatedTrackerDataInterface {
    const trackerData: EmarsysBookingParameterRelatedTrackerDataInterface = {};
    const datePipe = new DatePipe('en-US');

    trackerData.viewedStartDate = datePipe.transform(
      bookingParameters.start,
      'yyyy-MM-dd',
      undefined,
      'en-US'
    );
    trackerData.viewedEndDate = datePipe.transform(bookingParameters.end, 'yyyy-MM-dd', undefined, 'en-US');
    trackerData.adultNumber = bookingParameters.ages.filter(age => age >= 36).length;
    trackerData.childNumber = bookingParameters.ages.filter(age => age < 36).length;

    return trackerData;
  }

  getShopRelatedData(shop: ShopListInterface): EmarsysShopRelatedTrackerDataInterface {
    const trackerData: EmarsysShopRelatedTrackerDataInterface = {};

    trackerData.viewedTown = shop.townName;
    trackerData.viewedShop = shop.name;
    trackerData.viewedShopImage = this.platformInformationService.getHostname() + shop.imagePath;
    trackerData.viewedShopAddress = shop.address;
    trackerData.viewedShopDiscount = Math.round(shop.discount * 100);
    if (!shop.unbookable_reasons || shop.unbookable_reasons.length === 0) {
      trackerData.viewedPrice = Math.round(shop.defaultProductOnlinePriceRaw);
    }

    return trackerData;
  }
}
